import styled from 'styled-components';

import { sizeDown, sizeUp } from '~/theme';

export const Toolbar = styled.div(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const VerticalToolbar = styled.div(() => ({
  position: 'absolute',
  width: 'min-content',
  bottom: sizeDown('60rem', ['md', '20rem']),
  left: sizeUp('-40rem', ['sm', '20rem']),
}));
